import { gql } from '@apollo/client';

import { DeliveryLineFragment } from '~/@store/deliveryLines';

export const CreateDeliveryLineFromProjectMutation = gql`
    mutation CreateDeliveryLineFromProjectMutation($input: DeliveryLineSenderCreateInput!) {
        deliveryLineSenderCreate(input: $input) {
            ...DeliveryLineFragment
        }
    }

    ${DeliveryLineFragment}
`;

export const UpdateDeliveryLineFromProjectMutation = gql`
    mutation UpdateDeliveryLineFromProjectMutation($input: DeliveryLineSenderUpdateInput!) {
        deliveryLineSenderUpdate(input: $input) {
            ...DeliveryLineFragment
        }
    }

    ${DeliveryLineFragment}
`;

export const ChangeDeliveryLineOrderMutation = gql`
    mutation ChangeDeliveryLineOrderMutation($input: DeliveryLineOrderChangeInput!) {
        deliveryLineOrderChange(input: $input) {
            ...DeliveryLineFragment
        }
    }

    ${DeliveryLineFragment}
`;

export const DeleteDeliveryLineFromProjectMutation = gql`
    mutation DeleteDeliveryLineFromProjectMutation($id: ID!) {
        deliveryLineDelete(id: $id)
    }
`;
